// Auto-generated mock data - 2025-08-03T05:54:49.713Z
// Run 'npm run data:generate' to regenerate

export interface Dataset {
  id: string;
  name: string;
  description: string;
  domain: string;
  source: string;
  records: number;
  fields: string[];
  lastUpdated: string;
  size: string;
  format: string;
  quality: number;
  tags: string[];
}

export interface APISource {
  id: string;
  name: string;
  description: string;
  url: string;
  category: string;
  status: string;
  rateLimit: string;
  apiKey: string;
}

export const mockDatasets: Dataset[] = [
  {
    "id": "healthcare_1",
    "name": "Healthcare Dataset 1",
    "description": "Sample healthcare research data for analysis",
    "domain": "healthcare",
    "source": "API_1",
    "records": 3154,
    "fields": [
      "id",
      "timestamp",
      "location",
      "patient_id",
      "diagnosis",
      "treatment",
      "outcome"
    ],
    "lastUpdated": "2025-07-23T14:50:22.582Z",
    "size": "34.4MB",
    "format": "JSON",
    "quality": 88,
    "tags": [
      "medical",
      "patient-data",
      "research"
    ]
  },
  {
    "id": "healthcare_2",
    "name": "Healthcare Dataset 2",
    "description": "Sample healthcare research data for analysis",
    "domain": "healthcare",
    "source": "API_1",
    "records": 8684,
    "fields": [
      "id",
      "timestamp",
      "location",
      "patient_id",
      "diagnosis",
      "treatment",
      "outcome"
    ],
    "lastUpdated": "2025-07-18T03:38:19.342Z",
    "size": "35.4MB",
    "format": "JSON",
    "quality": 85,
    "tags": [
      "medical",
      "patient-data",
      "research"
    ]
  },
  {
    "id": "healthcare_3",
    "name": "Healthcare Dataset 3",
    "description": "Sample healthcare research data for analysis",
    "domain": "healthcare",
    "source": "API_1",
    "records": 5941,
    "fields": [
      "id",
      "timestamp",
      "location",
      "patient_id",
      "diagnosis",
      "treatment",
      "outcome"
    ],
    "lastUpdated": "2025-07-15T23:55:11.410Z",
    "size": "42.7MB",
    "format": "JSON",
    "quality": 92,
    "tags": [
      "medical",
      "patient-data",
      "research"
    ]
  },
  {
    "id": "healthcare_4",
    "name": "Healthcare Dataset 4",
    "description": "Sample healthcare research data for analysis",
    "domain": "healthcare",
    "source": "API_1",
    "records": 1215,
    "fields": [
      "id",
      "timestamp",
      "location",
      "patient_id",
      "diagnosis",
      "treatment",
      "outcome"
    ],
    "lastUpdated": "2025-07-27T16:31:02.144Z",
    "size": "50.9MB",
    "format": "JSON",
    "quality": 80,
    "tags": [
      "medical",
      "patient-data",
      "research"
    ]
  },
  {
    "id": "healthcare_5",
    "name": "Healthcare Dataset 5",
    "description": "Sample healthcare research data for analysis",
    "domain": "healthcare",
    "source": "API_1",
    "records": 8390,
    "fields": [
      "id",
      "timestamp",
      "location",
      "patient_id",
      "diagnosis",
      "treatment",
      "outcome"
    ],
    "lastUpdated": "2025-07-20T20:36:39.366Z",
    "size": "12.6MB",
    "format": "JSON",
    "quality": 96,
    "tags": [
      "medical",
      "patient-data",
      "research"
    ]
  },
  {
    "id": "environment_1",
    "name": "Environment Dataset 1",
    "description": "Sample environment research data for analysis",
    "domain": "environment",
    "source": "API_2",
    "records": 8525,
    "fields": [
      "id",
      "timestamp",
      "location",
      "temperature",
      "humidity",
      "pollution_level",
      "air_quality"
    ],
    "lastUpdated": "2025-07-12T12:11:47.878Z",
    "size": "21.3MB",
    "format": "JSON",
    "quality": 95,
    "tags": [
      "climate",
      "sustainability",
      "research"
    ]
  },
  {
    "id": "environment_2",
    "name": "Environment Dataset 2",
    "description": "Sample environment research data for analysis",
    "domain": "environment",
    "source": "API_2",
    "records": 9379,
    "fields": [
      "id",
      "timestamp",
      "location",
      "temperature",
      "humidity",
      "pollution_level",
      "air_quality"
    ],
    "lastUpdated": "2025-08-02T00:56:46.333Z",
    "size": "8.9MB",
    "format": "JSON",
    "quality": 97,
    "tags": [
      "climate",
      "sustainability",
      "research"
    ]
  },
  {
    "id": "environment_3",
    "name": "Environment Dataset 3",
    "description": "Sample environment research data for analysis",
    "domain": "environment",
    "source": "API_2",
    "records": 9392,
    "fields": [
      "id",
      "timestamp",
      "location",
      "temperature",
      "humidity",
      "pollution_level",
      "air_quality"
    ],
    "lastUpdated": "2025-08-01T19:14:49.687Z",
    "size": "35.8MB",
    "format": "JSON",
    "quality": 84,
    "tags": [
      "climate",
      "sustainability",
      "research"
    ]
  },
  {
    "id": "environment_4",
    "name": "Environment Dataset 4",
    "description": "Sample environment research data for analysis",
    "domain": "environment",
    "source": "API_2",
    "records": 1411,
    "fields": [
      "id",
      "timestamp",
      "location",
      "temperature",
      "humidity",
      "pollution_level",
      "air_quality"
    ],
    "lastUpdated": "2025-07-23T23:52:55.497Z",
    "size": "41.9MB",
    "format": "JSON",
    "quality": 97,
    "tags": [
      "climate",
      "sustainability",
      "research"
    ]
  },
  {
    "id": "environment_5",
    "name": "Environment Dataset 5",
    "description": "Sample environment research data for analysis",
    "domain": "environment",
    "source": "API_2",
    "records": 1002,
    "fields": [
      "id",
      "timestamp",
      "location",
      "temperature",
      "humidity",
      "pollution_level",
      "air_quality"
    ],
    "lastUpdated": "2025-07-24T14:57:23.438Z",
    "size": "20.0MB",
    "format": "JSON",
    "quality": 98,
    "tags": [
      "climate",
      "sustainability",
      "research"
    ]
  },
  {
    "id": "economics_1",
    "name": "Economics Dataset 1",
    "description": "Sample economics research data for analysis",
    "domain": "economics",
    "source": "API_3",
    "records": 6732,
    "fields": [
      "id",
      "timestamp",
      "location",
      "gdp",
      "unemployment_rate",
      "inflation",
      "trade_balance"
    ],
    "lastUpdated": "2025-07-14T09:59:00.972Z",
    "size": "27.5MB",
    "format": "JSON",
    "quality": 96,
    "tags": [
      "finance",
      "market-data",
      "research"
    ]
  },
  {
    "id": "economics_2",
    "name": "Economics Dataset 2",
    "description": "Sample economics research data for analysis",
    "domain": "economics",
    "source": "API_3",
    "records": 8953,
    "fields": [
      "id",
      "timestamp",
      "location",
      "gdp",
      "unemployment_rate",
      "inflation",
      "trade_balance"
    ],
    "lastUpdated": "2025-07-18T22:51:59.862Z",
    "size": "32.1MB",
    "format": "JSON",
    "quality": 84,
    "tags": [
      "finance",
      "market-data",
      "research"
    ]
  },
  {
    "id": "economics_3",
    "name": "Economics Dataset 3",
    "description": "Sample economics research data for analysis",
    "domain": "economics",
    "source": "API_3",
    "records": 8403,
    "fields": [
      "id",
      "timestamp",
      "location",
      "gdp",
      "unemployment_rate",
      "inflation",
      "trade_balance"
    ],
    "lastUpdated": "2025-07-22T19:26:39.374Z",
    "size": "5.0MB",
    "format": "JSON",
    "quality": 95,
    "tags": [
      "finance",
      "market-data",
      "research"
    ]
  },
  {
    "id": "economics_4",
    "name": "Economics Dataset 4",
    "description": "Sample economics research data for analysis",
    "domain": "economics",
    "source": "API_3",
    "records": 5417,
    "fields": [
      "id",
      "timestamp",
      "location",
      "gdp",
      "unemployment_rate",
      "inflation",
      "trade_balance"
    ],
    "lastUpdated": "2025-07-25T17:18:53.353Z",
    "size": "38.1MB",
    "format": "JSON",
    "quality": 88,
    "tags": [
      "finance",
      "market-data",
      "research"
    ]
  },
  {
    "id": "economics_5",
    "name": "Economics Dataset 5",
    "description": "Sample economics research data for analysis",
    "domain": "economics",
    "source": "API_3",
    "records": 8834,
    "fields": [
      "id",
      "timestamp",
      "location",
      "gdp",
      "unemployment_rate",
      "inflation",
      "trade_balance"
    ],
    "lastUpdated": "2025-07-16T13:15:16.006Z",
    "size": "41.7MB",
    "format": "JSON",
    "quality": 98,
    "tags": [
      "finance",
      "market-data",
      "research"
    ]
  },
  {
    "id": "technology_1",
    "name": "Technology Dataset 1",
    "description": "Sample technology research data for analysis",
    "domain": "technology",
    "source": "API_4",
    "records": 6553,
    "fields": [
      "id",
      "timestamp",
      "location",
      "language",
      "framework",
      "stars",
      "forks",
      "issues"
    ],
    "lastUpdated": "2025-07-14T11:48:52.986Z",
    "size": "18.5MB",
    "format": "JSON",
    "quality": 84,
    "tags": [
      "programming",
      "open-source",
      "research"
    ]
  },
  {
    "id": "technology_2",
    "name": "Technology Dataset 2",
    "description": "Sample technology research data for analysis",
    "domain": "technology",
    "source": "API_4",
    "records": 1215,
    "fields": [
      "id",
      "timestamp",
      "location",
      "language",
      "framework",
      "stars",
      "forks",
      "issues"
    ],
    "lastUpdated": "2025-07-23T22:18:32.436Z",
    "size": "50.5MB",
    "format": "JSON",
    "quality": 81,
    "tags": [
      "programming",
      "open-source",
      "research"
    ]
  },
  {
    "id": "technology_3",
    "name": "Technology Dataset 3",
    "description": "Sample technology research data for analysis",
    "domain": "technology",
    "source": "API_4",
    "records": 5235,
    "fields": [
      "id",
      "timestamp",
      "location",
      "language",
      "framework",
      "stars",
      "forks",
      "issues"
    ],
    "lastUpdated": "2025-08-03T00:37:55.523Z",
    "size": "38.4MB",
    "format": "JSON",
    "quality": 93,
    "tags": [
      "programming",
      "open-source",
      "research"
    ]
  },
  {
    "id": "technology_4",
    "name": "Technology Dataset 4",
    "description": "Sample technology research data for analysis",
    "domain": "technology",
    "source": "API_4",
    "records": 4611,
    "fields": [
      "id",
      "timestamp",
      "location",
      "language",
      "framework",
      "stars",
      "forks",
      "issues"
    ],
    "lastUpdated": "2025-07-07T16:55:42.188Z",
    "size": "54.2MB",
    "format": "JSON",
    "quality": 82,
    "tags": [
      "programming",
      "open-source",
      "research"
    ]
  },
  {
    "id": "technology_5",
    "name": "Technology Dataset 5",
    "description": "Sample technology research data for analysis",
    "domain": "technology",
    "source": "API_4",
    "records": 10817,
    "fields": [
      "id",
      "timestamp",
      "location",
      "language",
      "framework",
      "stars",
      "forks",
      "issues"
    ],
    "lastUpdated": "2025-07-04T15:43:40.578Z",
    "size": "52.4MB",
    "format": "JSON",
    "quality": 91,
    "tags": [
      "programming",
      "open-source",
      "research"
    ]
  },
  {
    "id": "social_1",
    "name": "Social Dataset 1",
    "description": "Sample social research data for analysis",
    "domain": "social",
    "source": "API_5",
    "records": 1321,
    "fields": [
      "id",
      "timestamp",
      "location",
      "age_group",
      "education_level",
      "income_bracket",
      "region"
    ],
    "lastUpdated": "2025-07-07T12:19:53.154Z",
    "size": "25.2MB",
    "format": "JSON",
    "quality": 97,
    "tags": [
      "demographics",
      "survey",
      "research"
    ]
  },
  {
    "id": "social_2",
    "name": "Social Dataset 2",
    "description": "Sample social research data for analysis",
    "domain": "social",
    "source": "API_5",
    "records": 6979,
    "fields": [
      "id",
      "timestamp",
      "location",
      "age_group",
      "education_level",
      "income_bracket",
      "region"
    ],
    "lastUpdated": "2025-07-27T12:51:38.045Z",
    "size": "9.7MB",
    "format": "JSON",
    "quality": 87,
    "tags": [
      "demographics",
      "survey",
      "research"
    ]
  },
  {
    "id": "social_3",
    "name": "Social Dataset 3",
    "description": "Sample social research data for analysis",
    "domain": "social",
    "source": "API_5",
    "records": 10841,
    "fields": [
      "id",
      "timestamp",
      "location",
      "age_group",
      "education_level",
      "income_bracket",
      "region"
    ],
    "lastUpdated": "2025-07-15T22:35:46.665Z",
    "size": "11.8MB",
    "format": "JSON",
    "quality": 81,
    "tags": [
      "demographics",
      "survey",
      "research"
    ]
  },
  {
    "id": "social_4",
    "name": "Social Dataset 4",
    "description": "Sample social research data for analysis",
    "domain": "social",
    "source": "API_5",
    "records": 9318,
    "fields": [
      "id",
      "timestamp",
      "location",
      "age_group",
      "education_level",
      "income_bracket",
      "region"
    ],
    "lastUpdated": "2025-07-06T18:29:37.920Z",
    "size": "22.7MB",
    "format": "JSON",
    "quality": 90,
    "tags": [
      "demographics",
      "survey",
      "research"
    ]
  },
  {
    "id": "social_5",
    "name": "Social Dataset 5",
    "description": "Sample social research data for analysis",
    "domain": "social",
    "source": "API_5",
    "records": 5462,
    "fields": [
      "id",
      "timestamp",
      "location",
      "age_group",
      "education_level",
      "income_bracket",
      "region"
    ],
    "lastUpdated": "2025-07-24T00:15:11.786Z",
    "size": "8.5MB",
    "format": "JSON",
    "quality": 95,
    "tags": [
      "demographics",
      "survey",
      "research"
    ]
  }
];

export const mockAPISources: APISource[] = [
  {
    "id": "API_1",
    "name": "Health Data API",
    "description": "Comprehensive health and medical research data",
    "url": "https://api.healthdata.gov",
    "category": "healthcare",
    "status": "active",
    "rateLimit": "1000/hour",
    "apiKey": "required"
  },
  {
    "id": "API_2",
    "name": "Climate Data Service",
    "description": "Global climate and environmental monitoring data",
    "url": "https://api.climate.gov",
    "category": "environment",
    "status": "active",
    "rateLimit": "500/hour",
    "apiKey": "optional"
  },
  {
    "id": "API_3",
    "name": "Economic Indicators",
    "description": "Financial and economic data from government sources",
    "url": "https://api.economic.gov",
    "category": "economics",
    "status": "active",
    "rateLimit": "2000/hour",
    "apiKey": "required"
  },
  {
    "id": "API_4",
    "name": "GitHub Research API",
    "description": "Open source project data and development metrics",
    "url": "https://api.github.com",
    "category": "technology",
    "status": "active",
    "rateLimit": "5000/hour",
    "apiKey": "required"
  },
  {
    "id": "API_5",
    "name": "Census Bureau API",
    "description": "Demographic and social research data",
    "url": "https://api.census.gov",
    "category": "social",
    "status": "active",
    "rateLimit": "1000/hour",
    "apiKey": "optional"
  }
];

export const researchDomainTemplates = [
  {
    id: 'healthcare',
    name: 'Healthcare & Medical Research',
    description: 'Analyze healthcare data, medical studies, and patient outcomes',
    icon: '🏥',
    color: '#0EA5E9',
    keywords: ['medical', 'healthcare', 'patient', 'clinical', 'diagnosis', 'treatment'],
    recommendedDatasets: ['healthcare_1', 'healthcare_2', 'healthcare_3'],
    commonAnalyses: ['Patient Outcome Analysis', 'Treatment Effectiveness', 'Diagnostic Patterns'],
    suggestedWorkflows: ['Patient Cohort Analysis', 'Clinical Trial Analysis', 'Healthcare Quality Metrics'],
    exampleQuestions: [
      'What factors influence patient recovery rates?',
      'How effective are different treatment protocols?',
      'What are the most common diagnostic patterns?'
    ],
    filterPreset: {
      domain: ['healthcare'],
      source: [],
      dateRange: { start: '', end: '' },
      qualityThreshold: 80
    }
  },
  {
    id: 'environment',
    name: 'Environmental Science',
    description: 'Study climate data, pollution levels, and environmental trends',
    icon: '🌍',
    color: '#10B981',
    keywords: ['climate', 'environment', 'pollution', 'sustainability', 'carbon', 'emissions'],
    recommendedDatasets: ['environment_1', 'environment_2', 'environment_3'],
    commonAnalyses: ['Climate Trend Analysis', 'Pollution Impact Assessment', 'Carbon Footprint Calculation'],
    suggestedWorkflows: ['Environmental Impact Study', 'Climate Change Analysis', 'Sustainability Metrics'],
    exampleQuestions: [
      'How has air quality changed over time?',
      'What are the main sources of carbon emissions?',
      'How do weather patterns affect pollution levels?'
    ],
    filterPreset: {
      domain: ['environment'],
      source: [],
      dateRange: { start: '', end: '' },
      qualityThreshold: 75
    }
  },
  {
    id: 'economics',
    name: 'Economics & Finance',
    description: 'Analyze market trends, economic indicators, and financial data',
    icon: '📊',
    color: '#F59E0B',
    keywords: ['economics', 'finance', 'market', 'stocks', 'trading', 'investment'],
    recommendedDatasets: ['economics_1', 'economics_2', 'economics_3'],
    commonAnalyses: ['Market Trend Analysis', 'Risk Assessment', 'Portfolio Performance'],
    suggestedWorkflows: ['Financial Risk Analysis', 'Market Prediction Model', 'Economic Indicator Tracking'],
    exampleQuestions: [
      'What factors drive market volatility?',
      'How do economic indicators correlate?',
      'What are the optimal investment strategies?'
    ],
    filterPreset: {
      domain: ['economics'],
      source: [],
      dateRange: { start: '', end: '' },
      qualityThreshold: 85
    }
  },
  {
    id: 'technology',
    name: 'Technology & Innovation',
    description: 'Explore tech trends, user behavior, and digital transformation',
    icon: '💻',
    color: '#8B5CF6',
    keywords: ['technology', 'software', 'digital', 'innovation', 'startup', 'tech'],
    recommendedDatasets: ['technology_1', 'technology_2', 'technology_3'],
    commonAnalyses: ['User Behavior Analysis', 'Technology Adoption Patterns', 'Innovation Metrics'],
    suggestedWorkflows: ['Product Analytics', 'User Journey Analysis', 'Technology Impact Assessment'],
    exampleQuestions: [
      'How do users interact with new technologies?',
      'What drives technology adoption rates?',
      'Which innovations have the highest impact?'
    ],
    filterPreset: {
      domain: ['technology'],
      source: [],
      dateRange: { start: '', end: '' },
      qualityThreshold: 80
    }
  },
  {
    id: 'social',
    name: 'Social Sciences',
    description: 'Study social behavior, demographics, and cultural trends',
    icon: '👥',
    color: '#EF4444',
    keywords: ['social', 'demographics', 'behavior', 'culture', 'society', 'community'],
    recommendedDatasets: ['social_1', 'social_2', 'social_3'],
    commonAnalyses: ['Demographic Analysis', 'Social Behavior Patterns', 'Cultural Trend Analysis'],
    suggestedWorkflows: ['Social Impact Study', 'Demographic Research', 'Community Analysis'],
    exampleQuestions: [
      'How do social trends vary by demographics?',
      'What factors influence community behavior?',
      'How do cultural changes affect society?'
    ],
    filterPreset: {
      domain: ['social'],
      source: [],
      dateRange: { start: '', end: '' },
      qualityThreshold: 75
    }
  }
];

// Quality reports for datasets
export const qualityReports = {
  "healthcare_1": {
    overall: 88,
    completeness: 92,
    accuracy: 85,
    consistency: 99,
    issues: []
  },
  "healthcare_2": {
    overall: 85,
    completeness: 88,
    accuracy: 94,
    consistency: 94,
    issues: []
  },
  "healthcare_3": {
    overall: 92,
    completeness: 85,
    accuracy: 97,
    consistency: 90,
    issues: []
  },
  "healthcare_4": {
    overall: 80,
    completeness: 90,
    accuracy: 93,
    consistency: 86,
    issues: []
  },
  "healthcare_5": {
    overall: 96,
    completeness: 83,
    accuracy: 95,
    consistency: 75,
    issues: []
  },
  "environment_1": {
    overall: 95,
    completeness: 91,
    accuracy: 94,
    consistency: 98,
    issues: []
  },
  "environment_2": {
    overall: 97,
    completeness: 99,
    accuracy: 87,
    consistency: 97,
    issues: []
  },
  "environment_3": {
    overall: 84,
    completeness: 86,
    accuracy: 92,
    consistency: 78,
    issues: []
  },
  "environment_4": {
    overall: 97,
    completeness: 90,
    accuracy: 96,
    consistency: 98,
    issues: []
  },
  "environment_5": {
    overall: 98,
    completeness: 94,
    accuracy: 97,
    consistency: 76,
    issues: []
  },
  "economics_1": {
    overall: 96,
    completeness: 84,
    accuracy: 86,
    consistency: 93,
    issues: []
  },
  "economics_2": {
    overall: 84,
    completeness: 81,
    accuracy: 95,
    consistency: 78,
    issues: []
  },
  "economics_3": {
    overall: 95,
    completeness: 96,
    accuracy: 96,
    consistency: 95,
    issues: []
  },
  "economics_4": {
    overall: 88,
    completeness: 84,
    accuracy: 92,
    consistency: 80,
    issues: []
  },
  "economics_5": {
    overall: 98,
    completeness: 87,
    accuracy: 95,
    consistency: 84,
    issues: []
  },
  "technology_1": {
    overall: 84,
    completeness: 95,
    accuracy: 92,
    consistency: 86,
    issues: []
  },
  "technology_2": {
    overall: 81,
    completeness: 98,
    accuracy: 85,
    consistency: 90,
    issues: []
  },
  "technology_3": {
    overall: 93,
    completeness: 82,
    accuracy: 93,
    consistency: 79,
    issues: []
  },
  "technology_4": {
    overall: 82,
    completeness: 83,
    accuracy: 90,
    consistency: 77,
    issues: []
  },
  "technology_5": {
    overall: 91,
    completeness: 99,
    accuracy: 85,
    consistency: 75,
    issues: []
  },
  "social_1": {
    overall: 97,
    completeness: 85,
    accuracy: 91,
    consistency: 77,
    issues: []
  },
  "social_2": {
    overall: 87,
    completeness: 99,
    accuracy: 85,
    consistency: 80,
    issues: []
  },
  "social_3": {
    overall: 81,
    completeness: 85,
    accuracy: 91,
    consistency: 90,
    issues: []
  },
  "social_4": {
    overall: 90,
    completeness: 80,
    accuracy: 93,
    consistency: 76,
    issues: []
  },
  "social_5": {
    overall: 95,
    completeness: 80,
    accuracy: 90,
    consistency: 77,
    issues: []
  }
};

interface DataQualityReport {
  completeness: number;
  validity: number;
  consistency: number;
  uniqueness: number;
  issues: unknown[];
  recommendations: string[];
}

interface CorrelationResult {
  field1: string;
  field2: string;
  dataset1: string;
  dataset2: string;
  correlation: number;
  type: 'strong' | 'moderate' | 'weak';
  joinStrategy: 'inner' | 'left' | 'outer';
  confidence: number;
}

// Utility functions for data analysis
export function generateQualityReport(dataset: Dataset): DataQualityReport {
  // Get existing quality data if available
  const existing = qualityReports[dataset.id as keyof typeof qualityReports];
  
  if (existing) {
    return {
      completeness: existing.completeness,
      validity: existing.accuracy,
      consistency: existing.consistency,
      uniqueness: Math.min(95, existing.completeness + 5),
      issues: existing.issues,
      recommendations: [
        "Consider standardizing date formats across all records",
        "Validate email format in contact fields",
        "Remove duplicate entries based on primary key"
      ]
    };
  }

  // Generate default quality report
  return {
    completeness: Math.floor(Math.random() * 20) + 80,
    validity: Math.floor(Math.random() * 20) + 75,
    consistency: Math.floor(Math.random() * 25) + 70,
    uniqueness: Math.floor(Math.random() * 15) + 85,
    issues: [],
    recommendations: [
      "Review data collection processes",
      "Implement validation rules",
      "Consider data cleansing procedures"
    ]
  };
}

export function findCorrelations(datasets: Dataset[]): CorrelationResult[] {
  const correlations: CorrelationResult[] = [];
  
  // Generate mock correlations between datasets
  for (let i = 0; i < datasets.length; i++) {
    for (let j = i + 1; j < datasets.length; j++) {
      const dataset1 = datasets[i];
      const dataset2 = datasets[j];
      
      // Find common fields
      const commonFields = dataset1.fields.filter(field => 
        dataset2.fields.includes(field)
      );
      
      if (commonFields.length > 0) {
        commonFields.forEach(field => {
          const correlation = Math.random();
          let type: 'strong' | 'moderate' | 'weak';
          
          if (correlation > 0.7) type = 'strong';
          else if (correlation > 0.4) type = 'moderate';
          else type = 'weak';
          
          correlations.push({
            field1: field,
            field2: field,
            dataset1: dataset1.id,
            dataset2: dataset2.id,
            correlation: Math.round(correlation * 100) / 100,
            type,
            joinStrategy: 'inner' as const,
            confidence: Math.round((correlation * 0.8 + 0.2) * 100) / 100
          });
        });
      }
    }
  }
  
  return correlations.slice(0, 10); // Limit to 10 results
}
